export const titles = {
    followUs: {
        ARM: "հետևեք մեզ",
        ENG: "FOLLOW US",
        RUS: "ПОДПИСЫВАЙТЕСЬ НА НАС"
    },
    subscribe: {
        ARM: "ԲԱԺԱՆՈՐԴԱԳՐՎԵՔ ՄԵՐ ԷԼ. ՀԱՍՑԵ",
        ENG: "SUBSCRIBE TO OUR NEWS LETTER",
        RUS: "ПОДПИСЫВАЙТЕСЬ НА НАШУ НОВОСТНУЮ РАССЫЛКУ"
    },
    ourContacts: {
        ARM: "կապ մեզ հետ",
        ENG: "our contacts",
        RUS: "наши контакты"
    },
    pages: {
        ARM: "էջեր",
        ENG: "pages",
        RUS: "страницы"
    }
}

export const placeholder = {
    ARM: "Էլ. Փոստ",
    ENG: "EMAIL",
    RUS: "ЭЛ. ПИСЬМО"
}
